(() => {
/**
 * Customer Stories module - loaded only when feature is enabled and on customer-stories page.
 * Contains CSS and JS for the Customer Stories feature.
 */ 



/**
 * Case Studies Block
 * 
 * JavaScript for filtering case studies by use case and industry with AJAX
 */ /**
 * Cache of case study page URLs.
 * The key is the clean URL, the value is the HTML content.
 */ const $5ecd39114e1bccd7$var$caseStudyPageCache = new Map();
const $5ecd39114e1bccd7$var$caseStudyPageInFlight = new Map();
const $5ecd39114e1bccd7$var$caseStudyImagePreloaded = new Set();
const $5ecd39114e1bccd7$var$caseStudyImageInFlight = new Map();
let $5ecd39114e1bccd7$var$caseStudiesLoadController = null;
let $5ecd39114e1bccd7$var$userScrolledRecently = false;
let $5ecd39114e1bccd7$var$userScrollClearTimer = null;
/**
 * Preload a case study page and cache it.
 * @param {string} pageUrl - The URL of the page to load.
 * @returns {Promise<string>}
 */ async function $5ecd39114e1bccd7$var$preloadCaseStudyPage(pageUrl, fetchImages = true) {
    if (!pageUrl) throw new Error("Page URL is required");
    // Use the clean URL for the cache key to avoid unnecessary lookups.
    const cleanUrl = $5ecd39114e1bccd7$var$getCleanUrl(pageUrl).toString();
    if ($5ecd39114e1bccd7$var$caseStudyPageCache.has(cleanUrl)) {
        console.log("Cache hit for", cleanUrl, "from", pageUrl);
        return $5ecd39114e1bccd7$var$caseStudyPageCache.get(cleanUrl);
    }
    if ($5ecd39114e1bccd7$var$caseStudyPageInFlight.has(cleanUrl)) {
        console.log("Cache pending for", cleanUrl, "from", pageUrl);
        return $5ecd39114e1bccd7$var$caseStudyPageInFlight.get(cleanUrl);
    }
    const requestPromise = (async ()=>{
        // Fetch the raw HTML content from the full URL.
        const response = await fetch(pageUrl);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const caseStudiesContent = doc.querySelector("#case-studies-content");
        if (!caseStudiesContent || !caseStudiesContent?.innerHTML) {
            console.error("No content found in the fetched HTML");
            throw new Error("No content found in the fetched HTML");
        }
        const caseStudiesContentHtml = caseStudiesContent.innerHTML;
        $5ecd39114e1bccd7$var$caseStudyPageCache.set(cleanUrl, caseStudiesContentHtml);
        console.log("Cache miss for", cleanUrl, "from", pageUrl);
        /* Preload the images. */ if (fetchImages) {
            console.log("Preloading images for", cleanUrl, "from", pageUrl);
            const imageUrls = $5ecd39114e1bccd7$var$extractImageUrls(caseStudiesContent, pageUrl);
            Promise.allSettled(imageUrls.map($5ecd39114e1bccd7$var$preloadImage));
        }
        return caseStudiesContentHtml;
    })().catch((error)=>{
        console.error("Error preloading case study page:", error);
        throw error;
    }).finally(()=>{
        $5ecd39114e1bccd7$var$caseStudyPageInFlight.delete(cleanUrl);
    });
    $5ecd39114e1bccd7$var$caseStudyPageInFlight.set(cleanUrl, requestPromise);
    return requestPromise;
}
/**
 * Extract all image URLs from the case studies content element.
 * @param {Element} caseStudiesContent - The case studies content element.
 * @param {string} baseUrl - The base URL of the document.
 * @returns {string[]} The array of image URLs.
 */ function $5ecd39114e1bccd7$var$extractImageUrls(caseStudiesContent, baseUrl) {
    const urls = new Set();
    caseStudiesContent.querySelectorAll("img").forEach((img)=>{
        if (img.getAttribute("src")) urls.add(new URL(img.getAttribute("src"), baseUrl).toString());
        /* naive srcset handling: take all candidates */ const srcset = img.getAttribute("srcset");
        if (srcset) srcset.split(",").forEach((part)=>{
            const candidate = part.trim().split(/\s+/)[0];
            if (candidate) urls.add(new URL(candidate, baseUrl).toString());
        });
    });
    return [
        ...urls
    ];
}
/**
 * Preload an image.
 * @param {string} url - The URL of the image to preload.
 * @returns {Promise<void>}
 */ function $5ecd39114e1bccd7$var$preloadImage(url) {
    if ($5ecd39114e1bccd7$var$caseStudyImagePreloaded.has(url)) return Promise.resolve();
    if ($5ecd39114e1bccd7$var$caseStudyImageInFlight.has(url)) return $5ecd39114e1bccd7$var$caseStudyImageInFlight.get(url);
    const imagePromise = new Promise((resolve)=>{
        const img = new Image();
        img.onload = img.onerror = ()=>{
            $5ecd39114e1bccd7$var$caseStudyImagePreloaded.add(url);
            $5ecd39114e1bccd7$var$caseStudyImageInFlight.delete(url);
            resolve();
        };
        img.src = url;
        console.log("Preloading image:", url);
    });
    $5ecd39114e1bccd7$var$caseStudyImageInFlight.set(url, imagePromise);
    return imagePromise;
}
/**
 * Filter the case studies by use case and industry.
 * @returns {void}
 */ function $5ecd39114e1bccd7$var$filterCaseStudies() {
    const useCase = document.getElementById("use-case-filter")?.value || "";
    const industry = document.getElementById("industry-filter")?.value || "";
    const contentContainer = document.getElementById("case-studies-content");
    const url = $5ecd39114e1bccd7$var$clearSearchParams(contentContainer?.getAttribute("data-base-url") ?? window.location.href);
    if (!url) return;
    if (useCase) url.searchParams.set("use_case", useCase);
    if (industry) url.searchParams.set("industry", industry);
    $5ecd39114e1bccd7$var$toggleClearFiltersButton(useCase || industry);
    $5ecd39114e1bccd7$var$pushCleanUrl(url);
    $5ecd39114e1bccd7$var$loadCaseStudiesFromUrl(url);
    return;
}
/**
 * Clear the filters and load the case studies from the URL.
 * @returns {void}
 */ function $5ecd39114e1bccd7$var$clearFilters() {
    // Reset dropdowns
    document.getElementById("use-case-filter").value = "";
    document.getElementById("industry-filter").value = "";
    const contentContainer = document.getElementById("case-studies-content");
    const url = $5ecd39114e1bccd7$var$clearSearchParams(contentContainer?.getAttribute("data-base-url") ?? window.location.href);
    if (!url) return;
    $5ecd39114e1bccd7$var$toggleClearFiltersButton(false);
    $5ecd39114e1bccd7$var$pushCleanUrl(url);
    $5ecd39114e1bccd7$var$loadCaseStudiesFromUrl(url);
}
/**
 * Load the case studies from the URL.
 * @param {URL} url 
 * @returns {void}
 */ function $5ecd39114e1bccd7$var$loadCaseStudiesFromUrl(url, scroll = true) {
    if (!url) return;
    const contentContainer = document.getElementById("case-studies-content");
    if (!contentContainer) return;
    // Abort any in-flight request so we don't get multiple scrollIntoView calls
    if ($5ecd39114e1bccd7$var$caseStudiesLoadController) $5ecd39114e1bccd7$var$caseStudiesLoadController.abort();
    $5ecd39114e1bccd7$var$caseStudiesLoadController = new AbortController();
    const signal = $5ecd39114e1bccd7$var$caseStudiesLoadController.signal;
    // Reset so scroll works for this user-initiated load (filter/pagination)
    if (scroll) $5ecd39114e1bccd7$var$userScrolledRecently = false;
    contentContainer.style.opacity = "0.5";
    contentContainer.style.pointerEvents = "none";
    // Clone URL so we don’t mutate the browser URL
    const ajaxUrl = $5ecd39114e1bccd7$var$getAjaxUrl(url).toString();
    $5ecd39114e1bccd7$var$preloadCaseStudyPage(ajaxUrl).then((html)=>{
        if (signal.aborted) return;
        if (!html) {
            console.error("No content found in the fetched HTML fragment");
            return;
        }
        contentContainer.innerHTML = html;
        $5ecd39114e1bccd7$var$attachPaginationHandlers();
    }).catch((error)=>{
        if (error.name === "AbortError") return;
        console.error("Error loading case studies:", error);
    }).finally(()=>{
        if (!signal.aborted) {
            contentContainer.style.opacity = "1";
            contentContainer.style.pointerEvents = "auto";
        }
        if (scroll && !signal.aborted && !$5ecd39114e1bccd7$var$userScrolledRecently) document.querySelector("#case-studies")?.scrollIntoView({
            behavior: "smooth"
        });
    });
}
/**
 * Attach click handlers to the pagination links.
 */ function $5ecd39114e1bccd7$var$attachPaginationHandlers() {
    const paginationLinks = document.querySelectorAll(".case-studies-pagination__wrapper a");
    paginationLinks.forEach((link)=>{
        const href = link.getAttribute("href");
        if (!href) return;
        $5ecd39114e1bccd7$var$preloadCaseStudyPage(href, $5ecd39114e1bccd7$var$isDirectSibling(href));
        link.addEventListener("click", function(e) {
            e.preventDefault();
            const cleanUrl = $5ecd39114e1bccd7$var$pushCleanUrl(new URL(href, window.location.origin));
            this.setAttribute("href", cleanUrl.toString());
            $5ecd39114e1bccd7$var$loadCaseStudiesFromUrl(cleanUrl);
        });
    });
}
/**
 * Detect if a link is a direct sibling of the current page.
 * @param {string} href - The href of the link.
 * @returns {boolean} True if the link is a direct sibling of the current page, false otherwise.
 */ function $5ecd39114e1bccd7$var$isDirectSibling(href) {
    const hrefPaged = $5ecd39114e1bccd7$var$getPageNumber(href);
    const currentPaged = $5ecd39114e1bccd7$var$getPageNumber(window.location.href);
    return hrefPaged === currentPaged - 1 || hrefPaged === currentPaged + 1;
}
/**
 * Get page number from URL supporting both query and pretty permalink formats.
 * @param {string} urlString
 * @returns {number}
 */ function $5ecd39114e1bccd7$var$getPageNumber(urlString) {
    const absoluteUrl = new URL(urlString, window.location.origin);
    const pagedParam = Number(absoluteUrl.searchParams.get("paged"));
    if (Number.isFinite(pagedParam) && pagedParam > 0) return pagedParam;
    const pathMatch = absoluteUrl.pathname.match(/\/page\/(\d+)\/?$/);
    const pathPaged = pathMatch ? Number(pathMatch[1]) : 1;
    return Number.isFinite(pathPaged) && pathPaged > 0 ? pathPaged : 1;
}
/**
 * Get clean URL from pagination link.
 * @param {URL} maybeDirtyUrl 
 * @returns {URL} The clean URL.
 */ function $5ecd39114e1bccd7$var$getCleanUrl(maybeDirtyUrl) {
    const cleanUrl = new URL(maybeDirtyUrl.toString(), window.location.origin);
    cleanUrl.searchParams.delete("ajax");
    cleanUrl.searchParams.delete("per_page");
    return cleanUrl;
}
/**
 * Get AJAX URL from plain URL.
 * This is the URL that will be used to load the case studies from the server.
 * It includes the AJAX parameter and the per_page parameter.
 * @param {URL} plainUrl 
 * @returns {URL} The AJAX URL.
 */ function $5ecd39114e1bccd7$var$getAjaxUrl(plainUrl) {
    const ajaxUrl = new URL(plainUrl.toString());
    if (!ajaxUrl.searchParams.has("paged")) ajaxUrl.searchParams.set("paged", "1");
    ajaxUrl.searchParams.set("ajax", "1");
    ajaxUrl.searchParams.set("per_page", window.innerWidth >= 900 ? 6 : 3);
    return ajaxUrl;
}
/**
 * Strip Ajax from the URL and push to the browser history, return the clean URL.
 * @param {URL} maybeDirtyUrl 
 * @returns {URL} The clean URL.
 */ function $5ecd39114e1bccd7$var$pushCleanUrl(maybeDirtyUrl) {
    if (!maybeDirtyUrl) return;
    const cleanUrl = $5ecd39114e1bccd7$var$getCleanUrl(maybeDirtyUrl);
    window.history.pushState({}, "", cleanUrl);
    return cleanUrl;
}
/**
 * If the URL is not absolute, prepend the window.location.origin to it.
 * @param {string} url 
 * @returns {URL} The absolute URL.
 */ function $5ecd39114e1bccd7$var$getAbsoluteUrl(url) {
    const absoluteUrl = url.startsWith("http://") || url.startsWith("https://") ? new URL(url) : new URL(url, window.location.origin);
    // Remove pagination from path if present (pretty permalinks: /page/2/)
    absoluteUrl.pathname = absoluteUrl.pathname.replace(/\/page\/\d+\/?$/, "");
    // Ensure pathname ends with / if it's not empty
    if (absoluteUrl.pathname && !absoluteUrl.pathname.endsWith("/")) absoluteUrl.pathname += "/";
    return absoluteUrl;
}
/**
 * Convert the URL string to a URL object and remove use_case, industry, and paged search params.
 * @param {string} url 
 * @returns {URL} The URL with the search params removed.
 */ function $5ecd39114e1bccd7$var$clearSearchParams(url) {
    const cleanUrl = new URL($5ecd39114e1bccd7$var$getAbsoluteUrl(url));
    cleanUrl.searchParams.delete("use_case");
    cleanUrl.searchParams.delete("industry");
    cleanUrl.searchParams.delete("paged");
    return cleanUrl;
}
/**
 * Toggle the visibility of the clear filters button.
 * If either use case or industry is selected, show the button.
 * @param {boolean} show - Whether to show the button.
 * @returns {void}
 */ function $5ecd39114e1bccd7$var$toggleClearFiltersButton(show = false) {
    let showButton = show;
    if (!showButton) {
        const useCase = document.getElementById("use-case-filter")?.value || "";
        const industry = document.getElementById("industry-filter")?.value || "";
        showButton = useCase || industry;
    }
    const clearFiltersButton = document.getElementById("clear-filters");
    if (clearFiltersButton) clearFiltersButton.classList.toggle("visible", showButton);
}
function $5ecd39114e1bccd7$var$onUserScroll() {
    $5ecd39114e1bccd7$var$userScrolledRecently = true;
    if ($5ecd39114e1bccd7$var$userScrollClearTimer) clearTimeout($5ecd39114e1bccd7$var$userScrollClearTimer);
    $5ecd39114e1bccd7$var$userScrollClearTimer = setTimeout(()=>{
        $5ecd39114e1bccd7$var$userScrolledRecently = false;
        $5ecd39114e1bccd7$var$userScrollClearTimer = null;
    }, 500);
}
document.addEventListener("DOMContentLoaded", function() {
    $5ecd39114e1bccd7$var$toggleClearFiltersButton(false);
    $5ecd39114e1bccd7$var$attachPaginationHandlers();
    const clearFiltersButton = document.getElementById("clear-filters");
    if (clearFiltersButton) clearFiltersButton.addEventListener("click", function(e) {
        e.preventDefault();
        $5ecd39114e1bccd7$var$clearFilters();
    });
    // Reload the case studies to show the correct number of case studies (without scrolling to the top).
    $5ecd39114e1bccd7$var$loadCaseStudiesFromUrl(window.location.href, false);
    // Skip scrollIntoView if user has manually scrolled (prevents automatic scroll from fighting/repeating)
    window.addEventListener("wheel", $5ecd39114e1bccd7$var$onUserScroll, {
        passive: true
    });
    window.addEventListener("touchmove", $5ecd39114e1bccd7$var$onUserScroll, {
        passive: true
    });
    // Preload the case study pages for the initial load.
    $5ecd39114e1bccd7$var$preloadCaseStudyPage($5ecd39114e1bccd7$var$getAjaxUrl(window.location.href).toString());
});
// Make functions available globally
window.filterCaseStudies = $5ecd39114e1bccd7$var$filterCaseStudies;
window.clearFilters = $5ecd39114e1bccd7$var$clearFilters;


/**
 * Customer Stories Cards JavaScript
 * Handles card carousel with main card + slices of off-screen cards.
 * On medium screens+: shows 1 main card (70%) with 10% slices of adjacent cards.
 * On small screens: full-width cards with single peek.
 */ document.addEventListener("DOMContentLoaded", function() {
    const animationDuration = 0.4;
    const animationStyle = "ease";
    const scrollContainer = document.querySelector("[data-cards-scroll]");
    const track = scrollContainer?.querySelector(".customer-stories-cards-track");
    const scrollLeftBtn = document.querySelector(".customer-stories-scroll-left");
    const scrollRightBtn = document.querySelector(".customer-stories-scroll-right");
    const cards = document.querySelectorAll(".customer-stories-card");
    if (!scrollContainer || !track || !scrollLeftBtn || !scrollRightBtn || !cards.length) return;
    const SLICE_WIDTH_PX = 64; // Fixed 64px width for slice peeks (matches Figma)
    const SLICE_GAP_PX = 16; // Fixed 16px gap between cards (matches Figma)
    let currentIndex = 0;
    let isAnimating = false;
    let isInitialLoad = true;
    let isResizing = false;
    let resizeEndTimer = null;
    function applyLayout() {
        const pageColumn = scrollContainer.closest(".l-container");
        const pageColumnWidth = pageColumn ? pageColumn.offsetWidth : scrollContainer.offsetWidth;
        const section = scrollContainer.closest("#customer-stories-cards");
        if (section) {
            section.classList.add("customer-stories-cards-slices-mode");
            section.style.setProperty("--card-main-width", pageColumnWidth + "px");
        }
        scrollContainer.classList.add("customer-stories-cards-slices-mode");
        scrollContainer.style.overflowX = "hidden";
        track.style.transform = "none";
        track.style.display = "flex";
        track.style.gap = SLICE_GAP_PX + "px";
        const sliceW = SLICE_WIDTH_PX;
        const viewportWidth = window.innerWidth;
        // Main card uses full page column width; slices sit outside in gutters
        const mainW = pageColumnWidth;
        const skipTransitions = isInitialLoad || isResizing;
        cards.forEach((card, i)=>{
            const w = i === currentIndex ? mainW : sliceW;
            card.style.width = w + "px";
            card.style.minWidth = w + "px";
            card.style.flexShrink = "0";
            card.style.transition = skipTransitions ? "none" : `width ${animationDuration}s ${animationStyle}, min-width ${animationDuration}s ${animationStyle}, opacity ${animationDuration}s ${animationStyle}`;
            card.classList.toggle("current", i === currentIndex);
        });
        // Align main card with page column: main card left edge = pageColumnRect.left
        const sumLeft = currentIndex * (sliceW + SLICE_GAP_PX);
        // Transform: scrollRect.left + translateX + sumLeft = pageColumnRect.left
        const applyTransform = ()=>{
            const scrollRect = scrollContainer.getBoundingClientRect();
            const pageColumnRect = pageColumn?.getBoundingClientRect();
            // translateX moves track; we want main card at pageColumnRect.left
            let translateX = pageColumnRect ? pageColumnRect.left - scrollRect.left - sumLeft : (viewportWidth - mainW) / 2 - sumLeft;
            // Clamp: don't show empty space on right (main card right edge <= scroll container right)
            const maxTranslateX = scrollRect.width - sumLeft - mainW;
            translateX = Math.min(translateX, maxTranslateX);
            track.style.transform = `translateX(${translateX}px)`;
        };
        track.style.transition = skipTransitions ? "none" : `transform ${animationDuration}s ${animationStyle}`;
        applyTransform();
        requestAnimationFrame(applyTransform);
    }
    function goToIndex(index) {
        if (isAnimating) return;
        index = Math.max(0, Math.min(index, cards.length - 1));
        if (index === currentIndex) return;
        isAnimating = true;
        currentIndex = index;
        applyLayout();
        setTimeout(()=>{
            isAnimating = false;
            updateButtons();
        }, animationDuration * 1000);
    }
    function updateButtons() {
        const lightGrey = "#ccc";
        const darkGrey = "#999";
        const black = "#333";
        const buttonOpacity = "0.5";
        scrollLeftBtn.style.opacity = currentIndex > 0 ? "1" : buttonOpacity;
        scrollLeftBtn.style.borderColor = currentIndex > 0 ? black : lightGrey;
        scrollLeftBtn.style.color = currentIndex > 0 ? black : darkGrey;
        scrollLeftBtn.classList.toggle("disabled", currentIndex === 0);
        scrollRightBtn.style.opacity = currentIndex < cards.length - 1 ? "1" : buttonOpacity;
        scrollRightBtn.style.borderColor = currentIndex < cards.length - 1 ? black : lightGrey;
        scrollRightBtn.style.color = currentIndex < cards.length - 1 ? black : darkGrey;
        scrollRightBtn.classList.toggle("disabled", currentIndex === cards.length - 1);
    }
    applyLayout();
    updateButtons();
    // Mark ready and enable transitions for subsequent interactions
    const section = scrollContainer.closest("#customer-stories-cards");
    if (section) section.classList.add("customer-stories-cards-ready");
    requestAnimationFrame(()=>{
        isInitialLoad = false;
    });
    scrollLeftBtn.addEventListener("click", ()=>goToIndex(currentIndex - 1));
    scrollRightBtn.addEventListener("click", ()=>goToIndex(currentIndex + 1));
    // Slices mode: click collapsed slice to bring it into view
    cards.forEach((card, i)=>{
        card.addEventListener("click", ()=>{
            if (i !== currentIndex) goToIndex(i);
        });
    });
    window.addEventListener("resize", ()=>{
        isResizing = true;
        const section = scrollContainer.closest("#customer-stories-cards");
        if (section) section.classList.add("customer-stories-cards-resizing");
        if (resizeEndTimer) clearTimeout(resizeEndTimer);
        resizeEndTimer = setTimeout(()=>{
            applyLayout(); // Final layout with settled dimensions
            isResizing = false;
            if (section) section.classList.remove("customer-stories-cards-resizing");
            resizeEndTimer = null;
        }, 150);
        currentIndex = 0;
        applyLayout();
        // Layout may not have settled yet; re-apply transform after browser has reflowed
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                const pageColumn = scrollContainer.closest(".l-container");
                const pageColumnWidth = pageColumn ? pageColumn.offsetWidth : scrollContainer.offsetWidth;
                const sliceW = SLICE_WIDTH_PX;
                const mainW = pageColumnWidth;
                const sumLeft = currentIndex * (sliceW + SLICE_GAP_PX);
                const scrollRect = scrollContainer.getBoundingClientRect();
                const pageColumnRect = pageColumn?.getBoundingClientRect();
                let translateX = pageColumnRect ? pageColumnRect.left - scrollRect.left - sumLeft : (window.innerWidth - mainW) / 2 - sumLeft;
                const maxTranslateX = scrollRect.width - sumLeft - mainW;
                translateX = Math.min(translateX, maxTranslateX);
                track.style.transform = `translateX(${translateX}px)`;
            });
        });
        updateButtons();
    });
    scrollContainer.style.cssText += "scrollbar-width: none; -ms-overflow-style: none;";
    const style = document.createElement("style");
    style.textContent = ".customer-stories-cards-scroll::-webkit-scrollbar { display: none; }";
    document.head.appendChild(style);
});


document.addEventListener("DOMContentLoaded", function() {
    const mobileQuery = window.matchMedia("(max-width: 899px)");
    const track = document.querySelector("[data-featured-case-studies-scroll]");
    const prevBtn = document.querySelector(".featured-case-studies-scroll-left");
    const nextBtn = document.querySelector(".featured-case-studies-scroll-right");
    if (!track || !prevBtn || !nextBtn) return;
    let currentIndex = 0;
    function getCards() {
        return Array.from(track.querySelectorAll(".card"));
    }
    function setButtonState(button, enabled) {
        const activeColor = "#ffffff";
        const disabledColor = "#8a8a8a";
        button.classList.toggle("disabled", !enabled);
        button.style.opacity = enabled ? "1" : "0.55";
        button.style.cursor = enabled ? "pointer" : "default";
        button.querySelectorAll("path").forEach((path)=>{
            path.style.fill = enabled ? activeColor : disabledColor;
        });
    }
    function updateButtons() {
        const cards = getCards();
        const maxIndex = Math.max(cards.length - 1, 0);
        setButtonState(prevBtn, currentIndex > 0);
        setButtonState(nextBtn, currentIndex < maxIndex);
    }
    function scrollToIndex(index) {
        const cards = getCards();
        if (!cards.length) return;
        const maxIndex = cards.length - 1;
        currentIndex = Math.max(0, Math.min(index, maxIndex));
        if (!mobileQuery.matches) {
            updateButtons();
            return;
        }
        const target = cards[currentIndex];
        if (!target) return;
        track.scrollTo({
            left: target.offsetLeft - track.offsetLeft,
            behavior: "smooth"
        });
        updateButtons();
    }
    function syncIndexFromScroll() {
        if (!mobileQuery.matches) return;
        const cards = getCards();
        if (!cards.length) return;
        const left = track.scrollLeft;
        let nearest = 0;
        let bestDistance = Number.POSITIVE_INFINITY;
        cards.forEach((card, index)=>{
            const distance = Math.abs(card.offsetLeft - track.offsetLeft - left);
            if (distance < bestDistance) {
                bestDistance = distance;
                nearest = index;
            }
        });
        currentIndex = nearest;
        updateButtons();
    }
    prevBtn.addEventListener("click", function() {
        scrollToIndex(currentIndex - 1);
    });
    nextBtn.addEventListener("click", function() {
        scrollToIndex(currentIndex + 1);
    });
    let scrollTimer = null;
    track.addEventListener("scroll", function() {
        if (scrollTimer) clearTimeout(scrollTimer);
        scrollTimer = setTimeout(syncIndexFromScroll, 100);
    });
    window.addEventListener("resize", function() {
        scrollToIndex(currentIndex);
    });
    scrollToIndex(0);
});



})();
//# sourceMappingURL=module-customer-stories.js.map
